// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.purchase_order_settings_menuBoxContainer__QWvkb {
    display: grid;
    grid-template-columns: 2fr 2fr 2fr 2fr 1fr;
    text-align: left;
    gap: 1rem;
    padding: 0.2rem 0;
    align-items: center;
}

.purchase_order_settings_menuBoxContainer__QWvkb input {
    width: 100%;
    padding: 0.3rem 0.5rem;
    font-size: 0.9rem;
    box-sizing: border-box;
    border-bottom: 1px solid #D1D5DB;
    height: 2rem;
    outline: none;
    border-top: none;
    border-right: none;
    border-left: none;
}


.purchase_order_settings_modalButton__mRuZa {
    display: flex;
    justify-content: space-between;
    margin-left: 1rem;
    margin-bottom: 1rem;
    padding: 6px 18px 6px 18px;
    border-radius: 6px;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    color: #FFFFFF;
    text-align: center;
    align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/modals/purchase_order_settings/index.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,0CAA0C;IAC1C,gBAAgB;IAChB,SAAS;IACT,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,iBAAiB;IACjB,sBAAsB;IACtB,gCAAgC;IAChC,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;AACrB;;;AAGA;IACI,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;IACjB,mBAAmB;IACnB,0BAA0B;IAC1B,kBAAkB;IAClB,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB","sourcesContent":[".menuBoxContainer {\n    display: grid;\n    grid-template-columns: 2fr 2fr 2fr 2fr 1fr;\n    text-align: left;\n    gap: 1rem;\n    padding: 0.2rem 0;\n    align-items: center;\n}\n\n.menuBoxContainer input {\n    width: 100%;\n    padding: 0.3rem 0.5rem;\n    font-size: 0.9rem;\n    box-sizing: border-box;\n    border-bottom: 1px solid #D1D5DB;\n    height: 2rem;\n    outline: none;\n    border-top: none;\n    border-right: none;\n    border-left: none;\n}\n\n\n.modalButton {\n    display: flex;\n    justify-content: space-between;\n    margin-left: 1rem;\n    margin-bottom: 1rem;\n    padding: 6px 18px 6px 18px;\n    border-radius: 6px;\n    cursor: pointer;\n    user-select: none;\n    color: #FFFFFF;\n    text-align: center;\n    align-items: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menuBoxContainer": `purchase_order_settings_menuBoxContainer__QWvkb`,
	"modalButton": `purchase_order_settings_modalButton__mRuZa`
};
export default ___CSS_LOADER_EXPORT___;
